import { Diagram } from '../diagram'
import type { TypedNode } from '../node/types'
import DolfinRecord from '../record'
import { DolfinRpc } from '../rpc'
import { DolfinRpcFactory } from '../rpc/factory'
import { NodeError, NodeWarning } from '../types'

export abstract class Action<TNode extends TypedNode<'custom-check'>> {
  protected node: TNode
  protected recordData: DolfinRecord
  protected organizationId: number
  protected rpcClient: DolfinRpc

  constructor(
    node: TNode,
    record: DolfinRecord,
    organizationId: number,
    rpcClient = DolfinRpcFactory.create()
  ) {
    this.node = node
    this.recordData = record
    this.organizationId = organizationId
    this.rpcClient = rpcClient
  }

  abstract run(): Promise<any>

  abstract parseVariables(): Record<string, string> | undefined

  static validate(
    _node: TypedNode<'custom-check'>,
    _diagram: Diagram
  ): {
    errors: NodeError[]
    warnings: NodeWarning[]
  } {
    return {
      errors: [],
      warnings: []
    }
  }
}
